import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetCoveredOversized extends AbstractProductType {

  name = 'valet_covered_oversized'
  title = 'Valet Covered Oversized'

  oversized = true
  valet = true
  format = ProductTypeFormat.Covered

}
